<template>
  <div>
    <div class="row expanded small-collapse img-txt-pnls">
      <div class="small-12 large-6 columns img video">
        <a v-on:click="play">
          <span>
            <span class="vd-aspct" v-bind:style='{ backgroundImage: "url(" + img + ")"}'></span>
          </span>
        </a>
      </div>
      <div class="small-12 large-6 columns txt">
        <div class="pddxy-50">
          <h3>In video:</h3>
          <h4>{{title}}</h4>
          <p>{{description | truncate(150, '...') }}</p>
          <p>&nbsp;</p>
          <p>
            <a href="#/" class="bttn-lrg" v-on:click="play">Watch video</a>
            <!--<a href="#/" class="bttn-lrg-arrw">More videos</a>-->
          </p>
        </div>
      </div>
    </div>
  
    <div class="reveal large" id="modal-ytvideo" data-reveal>
      <div class="responsive-embed widescreen">
        <!--<iframe id="player" type="text/html" width="1280" height="720" :src="embededUrl" frameborder="0"></iframe>-->
        <youtube :video-id="videoId" @ready="ready" @ended="ended"></youtube>
      </div>
      <button class="close-button" data-close aria-label="Close modal" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  
  </div>
</template>

<script>

export default {
  name: 'myyoutubeVideo',
  props: {
    videoid: {
      type: String,
      required: true
    }
  },
  mounted() {
    var el = $('#modal-ytvideo')
    this.reveal = new Foundation.Reveal(el, {
      // These options can be declarative using the data attributes
      animationIn: 'fade-in-up fast',
    })
    el.on('closed.zf.reveal', () => {
      this.player.stopVideo()
    })
  },
  data() {
    return {
      title: '',
      description: '',
      img: '',
      videoId: '',
      embededUrl: ''
    }
  },
  created: function () {

    var urlApi;

    if (this.videoid) {
      urlApi = 'https://www.googleapis.com/youtube/v3/videos?part=snippet&key=AIzaSyDXIMBUGd3h8aWTMguq31XuklzNZWmS7OA&id=' + this.videoid;
    }
    else {
      urlApi = 'https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=UC8O8LUiVMLWwTSyyiYlLD0g&maxResults=1&order=date&type=video&key=AIzaSyDXIMBUGd3h8aWTMguq31XuklzNZWmS7OA';
    }

    this.$http.get(urlApi).then((response) => {
      this.videoId = (response.body.items[0].id.videoId) ? response.body.items[0].id.videoId : response.body.items[0].id;
      this.title = response.body.items[0].snippet.title;
      this.description = response.body.items[0].snippet.description;
      this.embededUrl = 'http://www.youtube.com/embed/' + this.videoId;
      this.img = response.body.items[0].snippet.thumbnails.high.url;
    })
  },
  methods: {
    ready(player) {
      this.player = player
    },
    ended()
    {
    if (window.dataLayer != undefined) { window.dataLayer.push({ 'videoName': this.title, 'event': 'videoCompleteEvent' }); }
      console.log('We watched the video!');
    },
    play: function () {
      // reveal ty modal here
      this.reveal.open();
      this.player.playVideo();
      if (window.dataLayer != undefined) { window.dataLayer.push({ 'videoName': this.title, 'event': 'videoPlayEvent' }); }
    }
  }
}
</script>


// WEBPACK FOOTER //
// YoutubeVideo.vue?75964c3e